import { docReady } from './utils';
import plyrInit from './plyr';
import initMap from './googleMap';
import swiperInit from './swiper';
import tooltipInit from './tooltip';
import popoverInit from './popover';
import typedTextInit from './typed';
import progressBarInit from './progressbar';
import rellaxInit from './rellax';
import countupInit from './countup';
import isotopeInit from './isotope';
import zanimationInit from './zanimation';
import fancyNavInit from './fancynav';
import drawSvgInit from './drawsvg';
import preloaderInit from './preloader';
import bgPlayerInit from './bg-player';
import countdownInit from './countdown';
import lightboxInit from './lightbox';
import cookieNoticeInit from './notice';
import bootstrapNavbarInit from './bootstrap-navbar';


/* -------------------------------------------------------------------------- */
/*                            Theme Initialization                            */
/* -------------------------------------------------------------------------- */

docReady(fancyNavInit);
docReady(countdownInit);
docReady(plyrInit);
docReady(initMap);
docReady(tooltipInit);
docReady(popoverInit);
docReady(typedTextInit);
docReady(progressBarInit);
docReady(rellaxInit);
docReady(countupInit);
docReady(isotopeInit);
docReady(zanimationInit);
docReady(swiperInit);
docReady(drawSvgInit);
docReady(bgPlayerInit);
docReady(lightboxInit);
docReady(cookieNoticeInit);
docReady(bootstrapNavbarInit);
docReady(preloaderInit);


